module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_all":"Select All","unselect_all":"Unselect All","must_select":"Must select a value","no_element":"No elements","required_field":"Required field","search":"Search..."},"es":{"select_all":"Marcar Todos","unselect_all":"Desmarcar Todos","must_select":"Debe seleccionar un valor","no_element":"No hay elementos","required_field":"Campo requerido","search":"Buscar..."}}')
  delete Component.options._Ctor
}
